module.exports = __webpack_public_path__ + "img/13.b345d8fc.jpg";